<template>
	<div id="Clients" class="clients">
		<vue-snotify></vue-snotify>
		<!-- ######################################################################################
			 ####                                  Nav de opciones                             ####
			 ######################################################################################-->
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchClients"
					v-model="searchClients"
					v-on:keyup.enter="getAllClients(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllClients(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nuevo Cliento" @click="showClientModalComponent(0)">
					<i class="fas fa-plus"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsClient" @change="changeQRowsClient">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>

		<!-- ######################################################################################
			 ####                                  Lista de Clientes                           ####
			 ######################################################################################-->
		<table class="table table-sm table-hover table-12">
			<thead>
				<tr class="text-center">
					<th class="text-center" style="width: 10px">#</th>
					<th class="text-center">Nombre</th>
					<th class="text-center">Apellido</th>
					<th class="text-center">Email</th>
					<th class="text-center">Telefono</th>
					<th class="text-center">Tipo de Cliente</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listClients" :key="index">
					<td>{{ item.id }}</td>						
					<td>{{ item.name }}</td>						
					<td>{{ item.surname }}</td>						
					<td>{{ item.email }}</td>						
					<td>{{ item.phone }}</td>						
					<td>{{ item.type_client }}</td>						
					<td class="text-right">
						<i class="far fa-eye text-info margin-right5 pointer" @click="showClientModalComponent(item.id)"></i>
						<span class="badge bg-danger pointer margin-right5"><i class="far fa-trash-alt" @click="deleteClientLocal(item)"></i></span>
					</td>					
				</tr>
			</tbody>
		</table>
		
		<pagination :pagination="paginationClients" @getAllList="getAllClients"></pagination>
		
		<client-modal-component
			:id="clientId"
			@actionSaveClient="saveClientLocal"
			@deleteClientPriceList="deleteClientPriceList"
			ref="clientModalComponent">
		</client-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import client from '@/mixins/clients'
import clientPriceList from '@/mixins/clients/clientPriceList.js'

import Pagination from '@/components/Pagination.vue'
import ClientModalComponent from '@/components/ClientModalComponent.vue'

export default {
	name: 'Clients',
	mixins: [mixin, errors, axiosAction, clientPriceList, client],
	data() {
		return {
			clientId: 0
		}
	},
	computed: {
	},
	methods: {
		getAllTypesClientResultLocal(response) {},
		getAllPriceListsResultLocal(response) {},
		initModuleLocal() {
			this.qRowsClient = (localStorage.getItem('qRowsClient') === null) ? this.qRowsClient : localStorage.getItem('qRowsClient')
			this.typeStatusId = 1
			this.setTitleModule('Gestión de clientes')
			this.setSubTitleModule('')
			this.setListening()
		},
		hideLockScreenLocal(text) {
			this.$emit('hideLockScreen', text)
		},
		deleteClientLocal(item) {
			if(confirm('Esta a punto de borrar el cliente "' + item.name + ' (' + item.id + ')".\n¿Quiere continuar? ')) {
				this.deleteClient(item.id)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getAllClientsResult': this.getAllClientsResult(response); break;
				case 'deleteClientResult': this.deleteClientResult(response); break;
				case 'deleteClientPriceListResult': this.deleteClientPriceListResult(response); break;
				case 'showClientResult': this.showClientResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		saveClientLocal(data) {
			if(data.message == 'ACTUALIZADO') {
				this.updateItemListClients(data.data)
			} else if(data.message == 'NUEVO') {
				this.addListClients(data.data)
			}
		},
		saveClientResultLocal(response) {
		},
		setErrorSaveClientLocal(response) {
			this.messageErrorSave = response.data
			console.log(response)
			//this.$refs.newClient.$refs.btnShowNewClient.click()
		},
		setListening() {
			this.sockets.subscribe('DELETE_CLIENT', (data) => { this.deleteItemListClients(data.body) })
			this.sockets.subscribe('NEW_CLIENT', (data) => { this.addListClients(data.body) })
			this.sockets.subscribe('UPDATE_CLIENT', (data) => { this.updateItemListClients(data.body) })
		},
		showLockScreenLocal(text) {
			this.$emit('showLockScreen', text)
		},
		showClientModalComponent(id) {
			this.clientId = id
			this.$refs.clientModalComponent.$refs.btnShowClientModalComponent.click()
		},
		showClientResultLocal(response) {
			this.setObjectClient(response.data.data)
			this.$refs.btnShowClientModalComponent.click()
		}
	},
	components: {
		'pagination': Pagination,
		'client-modal-component': ClientModalComponent 
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>